<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fluid class="home">
        <div v-if = "userType === 2">
            <v-container fluid>
                

                

            </v-container>
        </div>
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex';

export default {
    name: 'home',
    data() {
        return {
            bDense: true,
            errorMessage: '',

        };
    },

    created() {
    },

    methods: {
    },
    computed: {
        ...mapGetters([
            'waitCursor',
            'isAuthenticated',
            'version',
            'userType',
            'userID',
        ]),

        loadingData: {
            get() {
                return this.$store.getters.loadingData;
            },
            set(loadingData) {
                this.$store.dispatch('updateLoadingData', loadingData);
            },
        },

        courseListHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '100px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '300px';
            } else {
                height = '500px';
            }
            return height;
        },

        term1DlgWidth() {
            var width;
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else {
                width = '30%';
            }
            return width;
        },

        configTermsDlgWidth() {
            var width;
            if (this.$vuetify.breakpoint.xs) {
                width = '100%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else {
                width = '40%';
            }
            return width;
        },

        sequenceOptionsDlgWidth() {
            var width;
            if (this.$vuetify.breakpoint.xs) {
                width = '100%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '90%';
            } else {
                width = '70%';
            }
            return width;
        },

    },

    watch: {

    },
};
</script>



<style scoped>
.home {
    background: url('../assets/fondo2.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}
.sub-window {
    /* background: rgba(89, 111, 133, 0.7); */
    background: rgba(0, 0, 0, 0.7);
    /* background: rgba(255, 255, 255, 0.5); */
}
.login-section {
    background: rgba(238, 238, 238, 0.85);
}

.my_black_text {
    color: black;
}

.my-list-title {
    font-size: 14px;
    font-weight: bold;
}

.semestre_actual {
    background-color: rgba(255, 0, 0, 0.2);
    border-radius: 50px;
}

.semestre_no_actual {
    background-color: rgba(150, 150, 150, 0.8);
    /* background-color: rgba(74, 20, 140, 0.4); */
    border-radius: 50px;
}

.nested {
    display: inline-block;
    vertical-align: top;
}

.prerreq {
    list-style-type: none;
    padding-left: 0;
    list-style-position: inside;
    text-indent: -1em;
    padding-left: 1em;
    
}

.my_pointer {
    cursor: pointer;
}


/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>
